const customTheme = {
  tokens: {
    colorTextAccent: {
      dark: "#0073bb",
    },
    colorBackgroundLayoutMain: {
      dark: "#0f141a",
    },
    colorBackgroundContainerContent: {
      dark: "#171D25",
    },
    colorBackgroundContainerHeader: {
      dark: "#171D25",
    },
    colorBackgroundNotificationSeverityHigh: {
      dark: "#ce3311",
    },
    colorBackgroundNotificationSeverityMedium: {
      dark: "#cc5f21",
    },
    colorBackgroundNotificationSeverityCritical: {
      dark: "#870303",
    },
    colorTextNotificationSeverityCritical: {
      dark: "#f9f9fa",
    },
    colorTextNotificationSeverityHigh: {
      dark: "#f9f9fa",
    },
    colorBackgroundControlDefault: {
      dark: "#171D25",
    },
    colorBackgroundInputDefault: {
      dark: "#171D25",
    },
    colorBackgroundHomeHeader: {
      dark: "#171D25",
    },
  },
};

export default customTheme;
